import { Trans } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'

import LazyImage from '@/components/LazyImage'


import Link from '@/components/Link';
export const OurMission: React.FC = () => {
  return (
    <div className='mx-auto max-w-[832px] px-4 pt-14 text-center md:pt-[120px]'>
      <LazyImage
        width={322}
        height={80}
        src={'/images/index/how-to.png'}
        alt=''
        className='mx-auto h-8 w-[130px] opacity-30 md:h-20 md:w-[322px]'
      />
      <H2 className='mt-4 md:mt-8'>
        <Trans>Our Mission</Trans>
      </H2>
      <p className='text-f-other-10 pt-3 text-sm md:pt-6 md:text-xl'>
        <Trans>
          At{' '}
          <Link href={'/'} className='text-f-primary hover:underline'>
            Tad.AI
          </Link>
          , our aim is to become the leading force for creators everywhere
          looking to bring their ideas to life without restriction. No longer
          will you need to restrain your musical ideas for a lack of experience
          or skill. Just describe to our AI music generator what you want and it
          will instantly help you create a near-perfect track that fits your
          vision within minutes.
        </Trans>
      </p>
    </div>
  )
}
